export const IOS_VERSIONS_UNSUPPORTED_H264 = ['15.1'];
export const IOS_VERSIONS_BUGGED_FIREWALL = [15];
export const IOS_VERSIONS_LOW_AUDIO = ['15.0', '15.1', '15.2', '15.3'];
export const SAFARI_VERSIONS_BUGGED_FIREWALL = [15];
export const SAFARI_VERSIONS_ECHO = ['15.0', '15.1', '15.2', '15.3', '15.4'];
